import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Constants } from '../common/Constants';

import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from './shared.service';
import { environment } from 'src/environments/environment';
import { LoginComponent } from '../shared/components/Login/Login.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
@Injectable({ providedIn: 'root' })
export class HTTPService {
    public baseWebSiteURL: string = environment.baseWebSiteURL;
    public baseURL: string = environment.baseURL;
    public rsvpURL: string = environment.rsvpURL;
    public baseURLWithOutSlace: string = environment.baseURLWithOutSlace;

    public constants: Constants;

    constructor(private ngbModel: NgbModal, private _http: HttpClient, private dialog: MatDialog,
        private _router: Router, public toastr: ToastrService, private sharedService: SharedService) {
        this.constants = new Constants();

    }

    ajaxPost(url: string, paramval?: any): Observable<any> {
        var headers = new HttpHeaders()
            .append('Content-Type', 'application/json')
        var isTokenAdded = false;
        if (JSON.parse(localStorage.getItem("userlocation")) != null) {
            headers = headers.append("ipAddress", JSON.parse(localStorage.getItem("userlocation"))?.ip);
        }
        if (localStorage.getItem("adminUserDetails") !== null && localStorage.getItem("adminUserDetails") !== "") {
            var userDetails = JSON.parse(localStorage.getItem("adminUserDetails"));
            if (userDetails != null) {
                headers = headers.append('Authorization', `Bearer ${userDetails.AuthToken}`);
                isTokenAdded = true;
            }
        }
        if (localStorage.getItem("userDetails") !== null && localStorage.getItem("userDetails") !== "" && !isTokenAdded) {
            var userDetails = JSON.parse(localStorage.getItem("userDetails"));
            if (userDetails != null) {
                headers = headers.append('Authorization', `Bearer ${userDetails.AuthToken}`);
            }
        }
        if (localStorage.getItem("deviceInfo") !== null && localStorage.getItem("deviceInfo") !== "") {
            var deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"));
            if (deviceInfo != null) {
                headers = headers.append('UserAgent', `${deviceInfo.userAgent}`);
                headers = headers.append('DeviceType', `${deviceInfo.deviceType}`);
            }
        }

        return this._http.post(this.baseURL + "api/" + url, JSON.stringify(paramval), { headers: headers });
        // .pipe(map((t: any) => {
        //     JSON.stringify(t);
        // }
        // ), catchError(this.handleServerError.bind(this)));

    }

    private handleServerError(error: Response) {
        if (error["status"] == 401) {
            //  alert("You are unauthorized"); 
            //localStorage.clear();
            localStorage.removeItem('setupTime');
            localStorage.removeItem('userDetails');
            const modelRef = this.ngbModel.open(LoginComponent, {
                size: 'lg',
                windowClass: 'login-dialog'
            });

            modelRef.result.then((data) => {
                let userDetails = JSON.parse(localStorage.getItem("userDetails"));
                if (userDetails != null && userDetails != '')
                    window.location.reload();
                else
                    this._router.navigate(['homepage']);
            });
        }
        let message = JSON.parse(error["_body"]).Status.Text;
        if (message.toLowerCase() !== "stop process")
            this.toastr.error(message);
        // return Observable.throw(message);
    }


    ajaxPostFileList(url: string, data: any[], params: any): Promise<any> {
        var file = data;
        return new Promise((resolve, reject) => {
            let xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open('POST', this.baseURL + "api/" + url, true);

            let formData = new FormData();
            for (var i = 0; i < data.length; i++) {
                formData.append("" + data[i].fieldName + "", data[i].file, data[i].file?.name?.replace(/\s/g, '_'));
            };
            formData.append("TemplateMetaData", JSON.stringify(params));
            var userDetails = JSON.parse(localStorage.getItem("userDetails"));
            if (userDetails != null) {
                xhr.setRequestHeader('Authorization', `Bearer ${userDetails.AuthToken}`);
            }
            else {
                var userDetails = JSON.parse(localStorage.getItem("adminUserDetails"));
                if (userDetails != null) {
                    xhr.setRequestHeader('Authorization', `Bearer ${userDetails.AuthToken}`);
                }
            }
            xhr.send(formData);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(<any>JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

        }
        );
    }

}